import { createContext } from 'react';

export const DelegateMattersContext = createContext(false);

export const ManageIncidentsContext = createContext(false);
